import request from 'axios';
import https from 'https';

const agent = new https.Agent({
  rejectUnauthorized: false,
});

const startUrl = process.env.VUE_APP_DOC_API_URL;
const langRu = [process.env.VUE_APP_LANG, process.env.VUE_APP_PROD_LANG].includes('ru');
const isKit = process.env.VUE_APP_INSTANCE === 'kit';

export function fetchPosts(url: string) {
  return request
    .get(startUrl + url, {
      httpsAgent: agent,
      ...(langRu && isKit ? { params: { lang: 'ru' } } : {}),
    })
    .then((response) => {
      return response;
    })
    .catch((error) => error);
}

export function fetchCancelableRequest(url: string, params?: any) {
  return request.get(startUrl + url, params).catch((error) => error);
}
